import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {UserResignationDgSearchResults} from "../models/datagrid-search-results/user-resignation.dg-search-results.model";
import {UserResignationService} from "../providers/user-resignation.service";

@Injectable()
export class UserResignationResolve implements Resolve<UserResignationDgSearchResults> {
  constructor(private userResignationService: UserResignationService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UserResignationDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.userResignationService.getResults(10, 0, 'desc', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
